import { Nav, NavDropdown } from 'react-bootstrap'
import Container from 'react-bootstrap/Container'
import Navbar from 'react-bootstrap/Navbar'
import '../style/style.css'
import { Link, Outlet } from 'react-router-dom'
import Image from 'react-bootstrap/Image'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { action } from 'mobx'
import { currencyValue } from './muiStyle/muiStyle'
import { useStore } from '../../app/stores/store'
import NotificationBell from './notifications/NotificationBell'

function CustomNav() {
  const { userStore, methodsStore, postListStore, bidsStore } = useStore()
  const { getData, user } = userStore
  const { t, i18n } = useTranslation()
  const [selectedCurrency, setSelectedCurrency] = useState(currencyValue[0].name)

  useEffect(() => {
    const savedCurrency =
      localStorage.getItem('ha_cookie') === 'true' ? localStorage.getItem('selectedCurrency') : null
    if (savedCurrency) {
      setSelectedCurrency(savedCurrency)
    }
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(
    action(() => {
      localStorage.setItem('selectedCurrency', selectedCurrency)
      postListStore.updateSelectedCurrency(selectedCurrency)
      methodsStore.selectedCurrency = selectedCurrency
      bidsStore.updateCurrentBidWithCurrency()
    }),
    [bidsStore, methodsStore, postListStore, selectedCurrency],
  )

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language)
    if(userStore.isLoggedIn){
      userStore.changeUserLanguage(language)
    }
  }

  const mainLinks = [
    { title: t('home'), link: '/' },
    { title: t('auctions'), link: '/auctions' },
    { title: t('posts'), link: '/posts' },
    { title: t('services'), link: '/services' },
  ]

  const renderBtns = [
    {
      title: t('favorites'),
      icon: 'fa-regular fa-heart fa-sm',
      link: '/favorites',
      show: true,
    },
    {
      title: t('log_in'),
      icon: 'fa-regular fa-user fa-sm',
      link: 'login',
      show: !userStore.isLoggedIn,
    },
  ]

  const dropDownLinks = [
    {
      title: t('dashboard'),
      icon: <DashboardOutlinedIcon className='me-2' />,
      link: '/dashboard',
      show: userStore.isAdmin,
    },
    {
      title: t('my_profile'),
      icon: <PersonOutlineOutlinedIcon className='me-2' />,
      link: 'profile',
      show: true,
    },
    {
      title: t('activity'),
      icon: <SettingsOutlinedIcon className='me-2' />,
      link: 'activity/my',
      show: true,
    },
    {
      title: t('log_out'),
      icon: <LogoutOutlinedIcon className=' me-2' />,
      onClick: () => userStore.logout(),
      className: 'border-0',
      show: true,
    },
  ]

  const languages: any = {
    en: { nativeName: t('english'), flag: 'gb' },
    de: { nativeName: t('german'), flag: 'ch' },
    it: { nativeName: t('italian'), flag: 'ch' },
    fr: { nativeName: t('french'), flag: 'ch' },
    // pl: { nativeName: t('polish'), flag: 'pl' },
  }

  return (
    <>
      <Navbar bg='light' data-bs-theme='light' expand='xl' className='bg-body-tertiary navNew'>
        <Container>
          <Navbar.Brand as={Link} to='/' className='resize-logo-mobile'>
            <img src='/images/Logo.png' className='logo-img-nav' alt='Home Auctions' />
          </Navbar.Brand>
          <div className='d-flex'>
            <div className='align-items-center hideBell'>
              <NotificationBell />
            </div>
            <Navbar.Toggle aria-controls='basic-navbar-nav' />
          </div>
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='ms-auto me-auto'>
              {mainLinks.map((link, index) => (
                <Nav.Link key={index} as={Link} to={link.link}>
                  {link.title}
                </Nav.Link>
              ))}
            </Nav>
            <Nav>
              {renderBtns.map((link, index) =>
                link.link
                  ? link.show && (
                      <Nav.Link as={Link} to={link.link} key={index}>
                        <i className={link.icon} />
                        <p>{link.title}</p>
                      </Nav.Link>
                    )
                  : link.show && (
                      <Nav.Link key={index}>
                        <button className='add-auction-btn'>
                          <i className={link.icon} /> {link.title}
                        </button>
                      </Nav.Link>
                    ),
              )}
              <NavDropdown
                align={{ lg: 'end' }}
                title={<span className={`fi fi-${t('flag')} fis`} />}
                id='nav-dropdown'
                drop='down'
                menuVariant='light'
                className='flag-dropdown justify-content-center'
              >
                {Object.keys(languages).map((language: any) => (
                  <NavDropdown.Item
                    onClick={() => changeLanguage(language)}
                    disabled={i18n.resolvedLanguage === language}
                    key={language}
                  >
                    <span className={`fi fi-${languages[language].flag} fis flag-shadow`} />
                    {languages[language].nativeName}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>

              <div className='d-flex justify-content-center'>
                <select
                  className='nav-currency'
                  name='currency'
                  onChange={(event) => setSelectedCurrency(event.target.value)}
                  value={selectedCurrency}
                >
                  {currencyValue.map((option) => (
                    <option key={option.value} className='text-center' value={option.name}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className='align-items-center hideBell2'>
                <NotificationBell />
              </div>
              {userStore.isLoggedIn && (
                <>
                  <div className='vr profile-line' />
                  <NavDropdown
                    align={{ lg: 'end' }}
                    title={
                      <Image
                        src={
                          user!.avatarId
                            ? user!.avatar
                            : getData.gender === 1
                              ? '/images/avatar/avatar1.png'
                              : getData.gender === 0
                                ? '/images/avatar/avatar2.png'
                                : getData.gender === 2
                                  ? '/images/avatar/avatar3.png'
                                  : '/images/avatar/avatar1.png'
                        }
                        style={{ height: 40, width: 40, borderRadius: '50%' }}
                      />
                    }
                    className='profile-dropdown justify-content-center'
                  >
                    {dropDownLinks.map(
                      (link, index) =>
                        link.show && (
                          <NavDropdown.Item
                            key={index}
                            as={Link}
                            to={link.link || '#'}
                            onClick={link.onClick}
                            className={link.className}
                          >
                            {link.icon}
                            {link.title}
                          </NavDropdown.Item>
                        ),
                    )}
                  </NavDropdown>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Outlet />
    </>
  )
}
export default observer(CustomNav)
